import { EditorPlugin } from './EditorPlugin';
import { RemixPlugin } from './RemixPlugin';
import { SandboxPlugin } from './SandboxPlugin';
import { InteractiveModePlugin } from './InteractiveModePlugin';
import { WorkflowsGenerateActionsPlugin } from './workflowsGenerateActionsPlugin/WorkflowsGenerateActionsPlugin';
const CopilotPlugins = {
  EditorPlugin,
  RemixPlugin,
  SandboxPlugin,
  WorkflowsGenerateActionsPlugin,
  InteractiveModePlugin
};
export default CopilotPlugins;